import { Grid, IconButton } from '@mui/material';
import { useRef } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import { PopoverTrigger } from 'src/components/PopoverTrigger';
import Iconify from 'src/components/iconify';
import { SoundBoardData } from 'src/requests/soundboard';
import { SoundBoardAddEditSoundPopover } from './SoundBoardAddEditSoundPopover';
import { SoundBoardButton, StyledTextItem } from './styles';

type Props = {
  sound: SoundBoardData;
  onSelectSound: (sound: Partial<SoundBoardData>) => void;
};

export const SoundBoardSoundItem = ({ sound, onSelectSound }: Props) => {
  const { user } = useAuthContext();
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Grid item xs={4} key={sound._id}>
      <SoundBoardButton
        size="small"
        variant="soft"
        disableElevation
        onClick={() => onSelectSound(sound)}
        ref={buttonRef}
      >
        <em-emoji shortcodes={sound.icon} />
        <StyledTextItem variant="body2">{sound.name}</StyledTextItem>
        {sound.createdBy === user?._id && (
          <PopoverTrigger
            popover={SoundBoardAddEditSoundPopover}
            context={{ sound }}
            onClick={(e) => e.stopPropagation()}
          >
            <IconButton className="iconConfig">
              <Iconify icon="tabler:settings-filled" />
            </IconButton>
          </PopoverTrigger>
        )}
      </SoundBoardButton>
    </Grid>
  );
};
